import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import Loading from '../../hoc/Loading/Loading';
import axios from '../../axios';
import * as actionCreators from '../../modules/actions/index';
import { connect } from 'react-redux';
import * as url from '../../utils/url';
import {whiteLabelStyling,isUserRemoved,groupContentFields, 
  hard_skills_list, soft_skills_list, skills_levels,
  groupPrivacyStatusDesc,genderMapOptions} from '../../utils/constants';
import {polarChartData} from '../../utils/formatChartdata';
import Toggle from "react-toggle";
import moment from 'moment';
import { Table, Modal, ModalBody, Button, ListGroupItem, Progress,DropdownMenu,DropdownToggle,Dropdown,Alert } from 'reactstrap'; 
import './ProfilePage.css';
import { isMobile } from "../../utils/deviceInfo"; 
import {createGrpStyle,customSearchStyle} from './SelectStyles'
import Select from "react-select";
import PlotlyChart from '../../components/CustomPlot/PlotlyChart';
import RaisedHand from '../../assets/raised_hand.svg';


const diversity_array=['dIRole','gender','ethnicity','sexualOrientation','religion', 'veteran','disability']

const theta_data=['A','B','C','D','E']


class ProfileGroups extends Component {
    constructor(props) {
        super(props);
        let currentUser = this.props.currentUser  
        let{skills}=currentUser
        this.state = {
            menu:1,
            currentUser,
            isGeoInput:false,
            isHandRaised: currentUser.isHandRaised,
            current_hard_skill: skills && skills.hard_skills? skills.hard_skills :[],
            current_soft_skill: skills && skills.soft_skills? skills.soft_skills :[],
            current_skills: skills && skills.current_skills.length>0? skills.current_skills:[],
            geolocate:{},
            occ_options:this.props.occupation && this.props.occupation.option?this.props.occupation.option:[],
            occupation: {
              value: currentUser.occupation && currentUser.occupation.reference? currentUser.occupation.reference: null,
              options:[],
              updatedValue: currentUser.occupation && currentUser.occupation.reference? currentUser.occupation.reference: null,
          },
            showEditProfileInfoModal: false,
            chart_data:[],
            theta_data:[],
            skill_codes:[],
            editExp:null,
            editInterest:null
         }
      this.timer=null;
    }

    updateDiversity= (value, obj) =>{
      if(value && value.value){
        obj['updatedValue']=value.value
        this.setState({obj})
      } else {
        obj['updatedValue']=null
        this.setState({obj})
      }
        
    }


    componentDidMount(){
      // appendScript("./RadarChart.js");

      // createPlot()
    }


    diversityValue = (div, userDiv) =>{
      if(div.options){
       if(div.updatedValue && (div.updatedValue.value || div.updatedValue)){
          let val = div.updatedValue?div.updatedValue:div.updatedValue.value
          let obj = div.options.filter(e=> {
            if(e.value===val){
              return  {
                value: e.value,
                label: e.label,
              }
            }
          })
          return obj[0]
        }else if(userDiv && userDiv.reference){
          let obj = div.options.filter(e=> {
            if(e.value=== userDiv.reference){
              return  { value: e.value,
                label: e.label}
            }
          })
        
          return obj[0]
       
        }
      } else {
        return null
      }
      
    }

    addSkill=(val,type)=>{
      if(val==null)val=[]
      let res, {current_hard_skill,current_soft_skill, chart_data }=this.state
      let current_skills = [...type=='hs'?current_soft_skill:current_hard_skill, ...val]
      let theta_data = current_skills.map(e=>e.name)
      let skill_codes = current_skills.map(e=>e.code)
      let skill_types = current_skills.map(e=>e.type)

      let new_chart_data 

      if(chart_data.length==0){
        new_chart_data = current_skills.map( (e,idx) =>{
          e=polarChartData(e,idx,theta_data, chart_data, skill_codes,skill_types)
          return e
        })
      } else {
        new_chart_data= chart_data.map(e=>{
          if(e.competency_id = skills_levels[0].id){
            e={
                ...e, 
                skill_id: val.map(e=> e.code),
                skill_type: val.map(e=> e.type),
                r: Array(current_skills.length).fill(1),
                theta:theta_data
              }
          }
          return e
        })
      }



      if(type=='hs'){
        res = {
          current_hard_skill:val
        }
      } else if (type=='ss'){
        res = {
          current_soft_skill:val
        }
      }
      
      this.setState(prevState=>({
        ...res,
        current_skills,
        theta_data,
        skill_codes,
        chart_data:new_chart_data
      }))
    }


    isEditExp=(item,idx)=>{
      console.log('idx --- ', idx)
      this.setState({editExp:idx})
    }

    isEditInterest=(item, idx)=>{
      this.setState({editInterest:idx})
    }

    
    updateExperience =(item, value)=>{
      let{chart_data}=this.state
      console.log('exp----', item)
      let item_type = skills_levels.filter(e=> e.id==item.experience)
      let results = chart_data.map(e=>{
        console.log('e----', e)
        if(e.name ==  item_type[0].name){
          let itm_idx = e.skill_id.indexOf(item.code)
          console.log('index ---', itm_idx)
          let {r} = e
          let res= r.map((e, idx) => idx==itm_idx? value: e)
          e = {...e, r: res}
        }
        return e
      })

      this.setState({chart_data:results})
      // let {target}=event
      // console.log('val---', target.data-skill)
    }

    updateInterest =(interest, value)=>{
      console.log('exp----', interest)
      // let {target}=event
      // console.log('val---', target)
    }

    handleRaiseHand=()=>{
      this.setState(prevState=>({isHandRaised: !prevState.isHandRaised }))
    }


    onKeyPress=(event, item, type)=>{
      const keyCode = event.keyCode || event.which;
      const keyValue = String.fromCharCode(keyCode);
      if (/\+|-/.test(keyValue)) event.preventDefault();
     
      let value = Number(event.target.value)
      if(type=='E'){
        this.updateExperience(item, value)
      }else if(type=='I'){
        this.updateInterest(item, value)
      }
    }


  renderProfile=()=>{
    // let{member:user}=this.props
    let {current_soft_skill,isHandRaised, current_hard_skill,editExp, editInterest,
      current_skills, currentUser,occ_options, theta_data,chart_data} = this.state
        // let {gender, occupation, seniority, religion, ethnicity, sexualOrientation,
        //   veteran, disability, birthDate}=this.props
          // console.log('occ--', occupation)
          let{occupation}=currentUser

          let my_user = this.props.user.profile

        return (
          <span>
            {/* flexRow */}
            <div className={`profile_page_about_container card  ${isMobile ? 'mt-2':'mt10'}`}>
           
           {/* { (currentUser && currentUser._id == this.props.user.profile._id)?
           <span className="profile_page_login_btn" 
          //  onClick={() => this.openProfileDetailsModal()}
           >
             <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
               <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z"/>
               <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z"/>
             </svg>
           </span>
           :null} */}



          <span className="flexRow">
            <span className="inline50">
           <div className="floating-label-group"> 
                    <Select name="kpi-select" 
                      placeholder={""} 
                      value = {this.props.occupation.updatedValue? this.diversityValue(this.props.occupation, this.props.user.profile.occupation, 'occupation') :null}
                      // optionRenderer={this.renderFieldOptions}
                      clearable={false}  
                      options={occ_options.sort(function (a, b) {
                        if (a.label < b.label) return -1;
                        else if (a.label > b.label) return 1;
                        return 0;
                      })} 
                      valueKey="value" labelKey="label"
                      getOptionLabel={({ label }) => label} getOptionValue={({ value }) => value}
                      onChange = {(e)=> this.updateDiversity(e, occupation)}
                      styles={customSearchStyle}
                      />
                  <label className={this.props.occupation.updatedValue!=null?'floating_label_invite_user':`floating-label`}> Occupation focus </label>
              </div>


              <div className="floating-label-group"> 
                    <Select name="kpi-select" 
                      placeholder={""} 
                      // value = {current_skills.filter(e=>e.type=='hs_01')}
                      value={current_hard_skill}
                      // optionRenderer={this.renderFieldOptions}
                      isMulti
                      clearable={false}  
                      options={hard_skills_list} 
                      valueKey="code" labelKey="name"
                      getOptionLabel={({ name }) => name} getOptionValue={({ code }) => code}
                      onChange = {(e)=>this.addSkill(e,'hs')}
                      styles={customSearchStyle}
                      />
                  <label className={current_hard_skill.length>0?'floating_label_invite_user':`floating-label`}> Technical skill(s) </label>
              </div>


              <div className="floating-label-group"> 
                    <Select name="kpi-select" 
                      placeholder={""} 
                      // value = {current_skills.filter(e=>e.type=='ss_01')}
                      value={current_soft_skill}
                      isMulti
                      // optionRenderer={this.renderFieldOptions}
                      clearable={false}  
                      options={soft_skills_list} 
                      valueKey="code" labelKey="name"
                      getOptionLabel={({ name }) => name} getOptionValue={({ code }) => code}
                      onChange = {(e)=>this.addSkill(e, 'ss')}
                      styles={customSearchStyle}
                      />
                  <label className={current_soft_skill.length>0?'floating_label_invite_user':`floating-label`}> Power skill(s) </label>
              </div>

            </span>           

          {current_skills && current_skills.length>0?
            <ul className="responsive-table inline50 user_profile_skills_table">
                  <li className="table-header user_profile_skills_table_header" 
                    // style={whiteLabelStyling(['backgroundColor'], this.props.user.profile.organizationId)}
                    >
                    <div className="col col-6">Skill</div>
                    <div className="col col-4">Competency</div>
                    <div className="col col-2">Interest</div>
                    {/* <div className="col col-1"></div> */}
                  </li>

                  {current_skills.map( (item,idx)=>{
                    return(<span className="grp_member_item_row_container" key={idx}>
                          <li className={`table-row`}  key={idx}>
                              <div className="col col-6"> {item.name}</div>
                              <div className="col col-4"   >
                                {editExp == idx?
                                   <input type="number" 
                                   value={item.experience}
                                   onChange={(e)=>this.onKeyPress(e, item, 'E')}
                                  //  onKeyPress={(e)=>this.onKeyPress(e, item, 'E')} 
                                   />
                                  :
                                  <div onClick={()=>this.isEditExp(item, idx)}>
                                      {item.experience}
                                  </div>
                                }
                              </div>
                              <div className="col col-2"  onClick={()=>this.isEditInterest(item, idx)} >
                              {editInterest == idx?
                                   <input type="number" 
                                   value={!item.interest?0:item.interest}
                                   onChange={(e)=>this.onKeyPress(e, item, 'I')}
                                  //  onKeyPress={(e)=>this.onKeyPress(e, item, 'I')} 
                                   />
                                  :
                                !item.interest?'N/A':item.interest
                              }
                              </div>
                              {/* <div className="col col-1"> 
                              <span onClick={()=>this.removeSkill()} 
                              className='chart-item-menu flaticon-trash'/> 
                              </div> */}
                          </li>
                    </span>)
                  })}
                </ul>
                :null}
          </span>


          
                  <Alert color="primary" className="user_profile_raise_hand_container">
                    <span className="alert-info-text">
                      {/* <span className="alert-info-icon"></span> */}
                      <span>
                          <div className="user_profile_raise_hand_title">Raise Hand  
                            {/* <i className="fa fa-hand-stop-o"></i> */}
                            <svg className="toggleCustomImage" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                  <path d="M480 128v208c0 97.05-78.95 176-176 176h-37.72c-53.42 0-103.7-20.8-141.4-58.58l-113.1-113.1C3.906 332.5 0 322.2 0 312C0 290.7 17.15 272 40 272c10.23 0 20.47 3.906 28.28 11.72L128 343.4V64c0-17.67 14.33-32 32-32s32 14.33 32 32l.0729 176C192.1 248.8 199.2 256 208 256s16.07-7.164 16.07-16L224 32c0-17.67 14.33-32 32-32s32 14.33 32 32l.0484 208c0 8.836 7.111 16 15.95 16S320 248.8 320 240L320 64c0-17.67 14.33-32 32-32s32 14.33 32 32l.0729 176c0 8.836 7.091 16 15.93 16S416 248.8 416 240V128c0-17.67 14.33-32 32-32S480 110.3 480 128z"/>
                                  </svg>
                          </div>
                          {current_skills && current_skills.length>0?
                          <span>
                          <div className="user_profile_raise_hand_desc">
                            By clicking on this...
                          </div>
                          <div className="user_profile_raise_hand_toggle">
                            <Toggle
                              defaultChecked={isHandRaised}
                              // icons={false}
                              icons={{
                                checked: <svg className="toggleCustomImage" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                  <path d="M480 128v208c0 97.05-78.95 176-176 176h-37.72c-53.42 0-103.7-20.8-141.4-58.58l-113.1-113.1C3.906 332.5 0 322.2 0 312C0 290.7 17.15 272 40 272c10.23 0 20.47 3.906 28.28 11.72L128 343.4V64c0-17.67 14.33-32 32-32s32 14.33 32 32l.0729 176C192.1 248.8 199.2 256 208 256s16.07-7.164 16.07-16L224 32c0-17.67 14.33-32 32-32s32 14.33 32 32l.0484 208c0 8.836 7.111 16 15.95 16S320 248.8 320 240L320 64c0-17.67 14.33-32 32-32s32 14.33 32 32l.0729 176c0 8.836 7.091 16 15.93 16S416 248.8 416 240V128c0-17.67 14.33-32 32-32S480 110.3 480 128z"/>
                                  </svg>,
                                // <img className="toggleCustomImage" src={RaisedHand}/>
                                unchecked: null,
                              }}
                              onChange={this.handleRaiseHand}
                            />
                          </div>
                          </span>:
                          <span>
                            Fill out your skills and this feature will... 
                          </span>
                        }

                      </span>
                    </span>
                  </Alert>   

           
       </div>







       <div className={`profile_page_about_container card ${isMobile ? 'mt-2':'mt10'}`}>
        
          {chart_data && chart_data.length>0?
            <PlotlyChart
              title={'Skills Data Visualization'}
              chartType={'polar'}
              data={chart_data}
              theta_data={theta_data}
            />
          :<span className="profile_page_skills_chart_no_data">
            Skills Data Visualization
          </span>}
            {/* <Plot
          data={[
            {
              type: 'barpolar',
              r: [5,0,0,0,0,0],
              theta: ['A','B','C', 'D', 'E',],
              fill: 'toself',
              name: 'Group A'
              },
              {
              type: 'barpolar',
              r:  [0,3,0,0,0,0],
              theta: ['A','B','C', 'D', 'E', ],
              fill: 'toself',
              name: 'Group B'
              }
           
          ]}
          layout={{
            width: 500,
            height: 500,
            title: `Skills`,
            polar: {
              radialaxis: {
                visible: true,
                range: [0, 5]
              }
            },
            showlegend: true
          }}
        /> */}

           
       </div>


       
          </span>
       
        )
      
     
  }

      render() {
        return this.renderProfile() 
    }
}



const mapStateToProps = state => {
    return {
      user: state.user,
      kpiMaster: state.kpiMaster,
      mappingMaster: state.mappingMaster,
      reports:state.reports
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
      onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
      onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
      updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
      updateReport: (dashboard)=> dispatch(actionCreators.updateReport(dashboard)),
    }
  }


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(ProfileGroups, axios)));